import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import type {
  CreateOrganisationFormFields,
  CreateOrganisationState,
  OrganisationType,
} from './create-organisation.types'
import { moduleName } from './create-organisation.types'

const emptyFields = (): CreateOrganisationFormFields => ({
  name: '',
  hubspotId: '',
  website: undefined,
  teamSize: undefined,
  contactName: undefined,
  email: undefined,
  phoneNumber: undefined,
  street: undefined,
  subStreet: undefined,
  town: undefined,
  postcode: undefined,
  region: undefined,
  associatedEmailDomains: undefined,
})

const initialState: CreateOrganisationState = {
  organisation: emptyFields(),
  charity: emptyFields(),
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    setField: <K extends keyof CreateOrganisationFormFields>(
      state: CreateOrganisationState,
      action: PayloadAction<{
        type: OrganisationType
        field: K
        value: CreateOrganisationFormFields[K]
      }>,
    ) => {
      const { type, field, value } = action.payload
      state[type][field] = value
    },
    resetForm: (state: CreateOrganisationState) => {
      state.organisation = emptyFields()
      state.charity = emptyFields()
    },
  },
})

export default slice
